'use client';
import {
  NotificationAction,
  notificationShowAction
} from '@/features/notifications/notificationsContext';
import { listingTranslate } from '@/i18n/translations/listingTranslations';

export const dispatchGeoNotification = (
  notificationDispatch: (action: NotificationAction) => void,
  type: 'UNAVAILABLE' | 'ERROR'
) => {
  const title =
    type === 'UNAVAILABLE'
      ? listingTranslate('locations.geo.position.unavailable')
      : listingTranslate('locations.geo.position.error');
  notificationDispatch(
    notificationShowAction({
      severity: type === 'UNAVAILABLE' ? 'info' : 'warning',
      title,
      description: listingTranslate('locations.geo.position.unavailable.description'),
      ttl: 7000
    })
  );
};
